export default __webpack_public_path__ + "static/media/CP512_AVT_LoopingBG_3.957ac397.mp4";